export const ns = 'cube3-client/ui';